module.exports = __webpack_public_path__ + "static/img/付晓峰.f02abc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/付晓峰.jpg
// module id = 9uak
// module chunks = 139